import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { Image } from "../../Image/Image/Image";
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import styles from "./SectionFour.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionFour = function SectionFour(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    button = _ref.button,
    images = _ref.images,
    footerText = _ref.footerText;
  return /*#__PURE__*/_jsx("div", {
    className: styles.sectionFour,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.left,
        children: [heading && /*#__PURE__*/_jsx(HeadingText, {
          richText: true,
          align: "left",
          className: styles.heading,
          typog: heading.typog,
          ariaLevel: heading.ariaLevel,
          children: heading.text
        }), subheading && /*#__PURE__*/_jsx(HeadingText, {
          richText: true,
          align: "left",
          className: styles.subheading,
          typog: subheading.typog,
          ariaLevel: subheading.ariaLevel,
          children: subheading.text
        }), button && /*#__PURE__*/_jsx("div", {
          className: styles.buttonWrap,
          children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, button), {}, {
            className: classnames(styles.button, styles.desktop)
          }))
        }), footerText && /*#__PURE__*/_jsx(Text, {
          richText: true,
          className: classnames(styles.footer, styles.desktop),
          typog: "bodycopyExtraSmall",
          children: footerText
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.right,
        children: images === null || images === void 0 ? void 0 : images.map(function (image, index) {
          return /*#__PURE__*/_jsx("div", {
            className: styles.section,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.imageWithCaption,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/_jsxs(Breakpoint, {
                  breakpoint: "medium",
                  children: [/*#__PURE__*/_jsx(Image, _objectSpread({
                    className: styles.image
                  }, image.image.mobile)), /*#__PURE__*/_jsx(Image, _objectSpread({
                    className: styles.image
                  }, image.image.desktop))]
                })
              }), /*#__PURE__*/_jsx(Text, {
                richText: true,
                className: styles.caption,
                typog: "bodycopyLarge",
                children: image.caption
              })]
            })
          }, "image-".concat(index));
        })
      }), button && /*#__PURE__*/_jsx("div", {
        className: styles.buttonWrap,
        children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, button), {}, {
          className: classnames(styles.button, styles.mobile)
        }))
      }), footerText && /*#__PURE__*/_jsx(Text, {
        align: "center",
        richText: true,
        className: classnames(styles.footer, styles.mobile),
        typog: "bodycopyExtraSmall",
        children: footerText
      })]
    })
  });
};